import { Button } from '@repo/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@repo/ui/dialog'
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@repo/ui/form'
import { useFormValidator, useT } from '@repo/ui/hooks'
import { Input } from '@repo/ui/input'
import { z } from '@repo/ui/lang'
import { useMemo } from 'react'

import { beneficiaryInsightsActions as actions } from '@/store/beneficiary-insights/slice'
import { useStoreDispatch, useStoreState } from '@/store/hooks'

export function InsightWidgetConfigurationEditDialog() {
  const { t } = useT({ keyPrefix: 'admin.insights.dashboard.editDialog' })
  const dispatch = useStoreDispatch()
  const open = useStoreState((state) => state.beneficiaryInsights.editDialog)
  const widgetConfig = useStoreState((state) => state.beneficiaryInsights.selectedWidgetConfig)

  const defaultValues = useMemo(
    () => ({
      position: widgetConfig?.position,
      width: widgetConfig?.width,
      height: widgetConfig?.height,
    }),
    [widgetConfig],
  )

  const { form, isFormValid, submit, submitOnPressMetaEnter } = useFormValidator({
    defaultValues,
    onSubmit: (values) => {
      void dispatch(
        actions.updateInsightConfigWidget({
          id: widgetConfig!.id,
          position: values.position,
          width: values.width,
          height: values.height,
        }),
      )
    },
    schema: z.object({
      position: z.coerce.number().min(1),
      width: z.coerce.number().min(1).max(6),
      height: z.coerce.number().min(1).max(6),
    }).shape,
  })

  return (
    <Dialog open={open} onOpenChange={() => dispatch(actions.closeWidgetDialog())}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('title')}</DialogTitle>
          <DialogDescription>{t('description')}</DialogDescription>
        </DialogHeader>

        <Form {...form}>
          <form onSubmit={submit} className="space-y-4" onKeyDown={submitOnPressMetaEnter}>
            <FormField
              control={form.control}
              name="position"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>{t('form.position')}</FormLabel>
                  <FormControl>
                    <Input placeholder={t('form.positionPlaceholder')} {...field} type="number" />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="width"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>{t('form.width')}</FormLabel>
                  <FormControl>
                    <Input placeholder={t('form.widthPlaceholder')} {...field} type="number" />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="height"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>{t('form.height')}</FormLabel>
                  <FormControl>
                    <Input placeholder={t('form.heightPlaceholder')} {...field} type="number" />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <Button type="submit" disabled={!isFormValid}>
              {t('update', { cfl: true })}
            </Button>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  )
}
